import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { NOMINATIONS_TAB } from "@e50/components/E50Constants";
import { TabType } from "@hooks/useTabs";
import { cn } from "@util/helpers";

type NominationsTabDesktopProps = {
  /** The function to change the tab state. */
  changeTab: (key: TabType) => void;
  /** The label string to get the active tab. */
  activeTab: string;
};

/**
 * Component to render E50 nominations tabs for desktop
 */
const NominationsTabDesktop = ({
  changeTab,
  activeTab,
}: NominationsTabDesktopProps): React.ReactElement => {
  return (
    <div
      className="mb-6 hidden gap-3 lg:flex"
      data-testid="nominations-tab-desktop-component"
    >
      {NOMINATIONS_TAB.map((tab) => (
        <ButtonFactory
          buttonType={ButtonType.Primary}
          text={tab.label}
          key={tab.key}
          onClick={() => {
            changeTab(tab.key);
          }}
          className={cn(
            "text-md rounded-full border border-gray-650 border-gray-750 bg-white px-4 py-2 font-public-sans font-medium text-gray-875 duration-200 hover:bg-white hover:text-gray-875",
            {
              "bg-gray-650 text-white hover:bg-gray-650 hover:text-white":
                activeTab === tab.key,
            }
          )}
        />
      ))}
    </div>
  );
};

export default NominationsTabDesktop;
